var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14344_185392)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M215.01 0H84.9751C34.1401 0 0 35.6701 0 88.7551V211.26C0 264.33 34.1401 300 84.9751 300H214.995C265.83 300 300 264.33 300 211.26V88.7551C300 35.6701 265.845 0 215.01 0Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.478 127.345H186.011C173.694 127.366 163.717 137.095 163.694 149.104C163.677 161.139 173.667 170.911 186.011 170.927H212.5V172.839C212.5 193.835 199.772 206.25 178.233 206.25H121.772C100.228 206.25 87.5 193.835 87.5 172.839V127.112C87.5 106.116 100.228 93.75 121.772 93.75H178.211C199.75 93.75 212.478 106.116 212.478 127.112V127.345ZM117.122 127.296H152.372H152.394H152.439C155.077 127.285 157.211 125.189 157.2 122.61C157.189 120.037 155.033 117.957 152.394 117.968H117.122C114.5 117.979 112.372 120.054 112.361 122.616C112.35 125.189 114.483 127.285 117.122 127.296Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M175.234 151.854C176.541 157.799 181.753 161.982 187.704 161.873H208.016C210.492 161.873 212.5 159.823 212.5 157.288V141.466C212.494 138.936 210.492 136.88 208.016 136.875H187.226C180.457 136.897 174.989 142.515 175 149.439C175 150.249 175.08 151.06 175.234 151.854Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5 155.625C190.952 155.625 193.75 152.827 193.75 149.375C193.75 145.923 190.952 143.125 187.5 143.125C184.048 143.125 181.25 145.923 181.25 149.375C181.25 152.827 184.048 155.625 187.5 155.625Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14344_185392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.1c30589269c4a302f85a62d8fc5edf1c.svg";
export { ForwardRef as ReactComponent };